import type { Process } from '../type/Process';

// Pre-fill trace fields default to null
const NULL_TRACE_FIELDS = {
  operator: null, operation: null,
  ae: null, ap: null, vc: null, fz: null,
  machinedVolume: null, machinedDistance: null, machinedPieces: null,
  totalMachiningDuration: null, pieceMachiningDuration: null, malround: null,
  lubType: null, lubBrand: null, holderBrand: null,
  holderType: null, clampingType: null, clampingBrand: null,
  materialLot: null,
} as const satisfies Partial<Process>;

const coerceStr = (v: string | null) => (v === null || v.trim() === '' ? null : v.trim());
const coerceNum = (v: number | null) => (v === null || Number.isNaN(v) ? null : v);

export function buildProcessPayload(fp: Process, companyName: string, trimmedName: string): Process {
  return {
    ...(fp.id !== undefined && { id: fp.id }),
    name: trimmedName,
    companyName,
    toolReference: fp.toolReference,
    processType: fp.processType,
    archived: fp.id !== undefined ? fp.archived : false,
    machineIds: fp.machineIds,
    mandatoryFields: fp.mandatoryFields,
    material: fp.material,
    materialLot: fp.materialLot,
    articleId: fp.articleId,
    operator: coerceStr(fp.operator),
    operation: coerceStr(fp.operation),
    ae: coerceNum(fp.ae), ap: coerceNum(fp.ap), vc: coerceNum(fp.vc), fz: coerceNum(fp.fz),
    machinedVolume: coerceNum(fp.machinedVolume), machinedDistance: coerceNum(fp.machinedDistance),
    machinedPieces: coerceNum(fp.machinedPieces),
    totalMachiningDuration: coerceNum(fp.totalMachiningDuration),
    pieceMachiningDuration: coerceNum(fp.pieceMachiningDuration), malround: coerceNum(fp.malround),
    lubType: coerceStr(fp.lubType), lubBrand: coerceStr(fp.lubBrand),
    holderBrand: coerceStr(fp.holderBrand), holderType: coerceStr(fp.holderType),
    clampingType: coerceStr(fp.clampingType), clampingBrand: coerceStr(fp.clampingBrand),
  };
}

export const DEFAULT_PROCESS = (companyName: string): Process => ({
  name: '',
  companyName,
  toolReference: '',
  processType: 'standard',
  archived: false,
  machineIds: [],
  mandatoryFields: ['ae', 'ap', 'vc', 'fz', 'pieces', 'malrond', 'operation', 'lubType', 'holderType', 'clampingType'],
  material: null,
  articleId: null,
  ...NULL_TRACE_FIELDS,
});
